import { registerBlockType } from "@wordpress/blocks";
import config, { type BlockAttributes } from "./block.json";
import "../slider/swiper";
import WrapperSave from "./wrapperSave";
import WrapperEditor from "./wrapperEditor";

registerBlockType<BlockAttributes>(config.name, {
  ...config,

  edit: WrapperEditor,
  save: WrapperSave,
});
